// import React, { useState, useMemo, useCallback, useEffect } from "react";
// import TextStyles from "../../../../../components/Elements/TextStyles/TextStyles";
// import { useLocation, useNavigate } from "react-router-dom";
// import { ReactComponent as BackIcon } from "../../../../../assets/svgs/back-button.svg";
// import { Button } from "antd";
// import StandardSurveyForm from "./StandardSurveyForm";
// import DynamicForm from "./DynamicForm";
// import UserTable from "./UserTable";
// import GenerateReport from "../DailogBoxes/GenerateReport";
// import AssignedForm from "../AssignedForm/AssignedForm";
// import ReportTable from "./ReportTable";
// import { getApi } from "../../../../../api/api_instance";
// import { API_URLS } from "../../../../../api/apiUrls";
// import dayjs from "dayjs";
// import { formatDate } from "../../../../../utils/UtilService";
// import ScreenLock from "../DailogBoxes/ScreenLock";
// import ProjectSetup from "../DailogBoxes/ProjectSetup";
// import ProjectDetailPage from "./ProjectDetailPage";
// import { IoArrowBackCircleOutline } from "react-icons/io5";
// const ProjectPage = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { projectName, projectId } = location.state || {};
//   const [openGenerateReports, setOpenGenerateReports] = useState(false);
//   const [openSetupProject, setopenSetupProject] = useState(false);
//   const [setupProject, setSetupProject] = useState(false);

//   const [openAssignedForm, setOpenAssignedForm] = useState(false);
//   const [openUserDetailsPage, setOpenUserDetailsPage] = useState(false);
//   const [selectedUsers, setSelectedUsers] = useState([]);
//   const [assignedFormType, setAssignedFormtype] = useState("");
//   const [openTableReports, setOpenTableReports] = useState(false);
//   const [projectData, setProjectData] = useState({});
//   const [selectedRole, setSelectedRole] = useState(null);
//   const [lockProject, setLockProject] = useState(false);
//   const [openScreenLockedPopup, setOpenScreenLockedPopup] = useState(false);
//   const [clientId, setClientId] = useState();
//   const [formId, setFormId] = useState(null);

//   const handleBack = useCallback(() => {
//     if (openTableReports) {
//       setOpenTableReports(false);
//     } else {
//       navigate("/organization/projects");
//     }
//   }, [navigate, openTableReports]);

//   const handleGenerateReport = useCallback(() => {
//     if (openTableReports) {
//       setOpenGenerateReports(true);
//     } else {
//       setOpenTableReports(true);
//     }
//   }, [openTableReports]);

//   const handleSetupProject = () => {
//     setopenSetupProject(true);
//   };

//   const handleAssigned = useCallback(() => {
//     setOpenAssignedForm(true);
//   }, []);

//   const fetchProjectDetails = useCallback(async () => {
//     try {
//       const response = await getApi({
//         apiUrl: API_URLS.GET_PROJECT_BY_ID(projectId),
//       });
//       if (response.success) {
//         let project_data = response.data;
//         setProjectData({
//           projectName: project_data.name,
//           startDate: dayjs(project_data.startDate).format("DD/MMM/YYYY"),
//           license: project_data.license,
//           projectType: project_data.project_type,
//           status: project_data.status,
//           ...project_data,
//         });
//         if (
//           project_data.status === "Project Setup Completed" &&
//           (project_data.frequency === null ||
//             project_data.frequency === undefined)
//         ) {
//           setLockProject(true);
//         }
//       }
//       setClientId(response.data.assigned_by || response.data.client_id);
//     } catch (error) {
//       console.error("Error is fetching project details");
//     }
//   });

//   const header = useMemo(
//     () => [
//       { label: "STATUS OF LICENSE", key: "statusOfLicense" },
//       { label: "TOTAL LICENSE", key: "totalLicense" },
//       { label: "USED", key: "used" },
//       { label: "REMAINING", key: "remaining" },
//     ],
//     [],
//   );

//   const licenseTableSample = useMemo(() => {
//     const license = projectData.license || {};
//     const licenseTypes = [
//       { key: "location_user", label: "LOCATION USER" },
//       { key: "location_admin", label: "LOCATION ADMIN" },
//       { key: "employee", label: "EMPLOYEE" },
//       { key: "vendor", label: "VENDOR" },
//     ];

//     const tableData = licenseTypes.map(({ key, label }) => {
//       const typeData = license[key] || {};
//       return {
//         statusOfLicense: label,
//         totalLicense: typeData.total ?? "10",
//         used: typeData.used ?? "10",
//         remaining: typeData.unused ?? "10",
//       };
//     });

//     return [{ key: 1, tableData }];
//   }, [projectData.license]);

//   const statusList = useMemo(
//     () => [
//       "Project Created",
//       "Project Setup Completed",
//       "Form Submission in Progress",
//       "Forms Submitted",
//       "Report Requested",
//       "Report Generated",
//       "Audit Requested",
//       'Audit in Progress',
//       'Audit Completed'
//     ],
//     [],
//   );

//   useEffect(() => {
//     fetchProjectDetails();
//   }, []);

//   useEffect(() => {
//     if (lockProject) {
//       // Optional: trigger popup or redirect
//     }
//   }, [lockProject]);

//   const currentStatus = projectData.status || "Project Created";
//   const currentStatusIndex = statusList.indexOf(currentStatus);

//   console.log("Current Status:", currentStatus); // Should show "Audit Completed"
//   console.log("Current Status Index:", currentStatusIndex); // Should show 8 (last index)
//   console.log("Status List:", statusList);

//   const licenseData = [
//     { role: "Location Admin", total: 15, used: 6, remaining: 6 },
//     { role: "Location User", total: 20, used: 12, remaining: 12 },
//     { role: "Employee", total: 20, used: 12, remaining: 12 },
//     { role: "Vendor", total: 10, used: 2, remaining: 2 },
//   ];

//   return (
//     <div className="md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
//       {/* Breadcrumb */}

//       <div className="flex flex-wrap justify-end text-xs h-5 font-light gap-1 sm:gap-2">
//         <p>Home</p>
//         <span>/</span>
//         <p>Projects</p>

//         <TextStyles style={{ color: "#06513D" }}>
//           {" "}
//           Project Detail Page
//         </TextStyles>
//       </div>

//       <div className="flex items-center gap-2 sm:mb-1.5 text-lg sm:text-xl font-bold flex-wrap">
//         <IoArrowBackCircleOutline
//           onClick={() => navigate(-1)}
//           className="w-8 sm:w-10 h-8 sm:h-10 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition"
//         />
//         <div className="text-[#06513D] font-[Calibri] text-[18px] sm:text-[20px] leading-none tracking-tight">
//           Project Details Page
//         </div>
//       </div>

//       {/* Project Details */}

//       {/* <div className="border border-[#3BA2B959] rounded-xl p-5 bg-white space-y-6 mt-4">
//         <div className="flex flex-col md:flex-row md:justify-between gap-4">
//           <div className="flex flex-col sm:flex-row gap-6 text-sm">
//             <div>
//               <p className="font-bold text-gray-600">Project Name</p>
//               <p>{projectName}</p>
//             </div>
//             <div>
//               <p className="font-bold text-gray-600">Start Date</p>
//               <p>{formatDate(projectData.startDate)}</p>
//             </div>
//             <div>
//               <p className="font-bold text-gray-600">End Date</p>
//               <p>{formatDate(projectData.endDate) || 'NA'}</p>
//             </div>
//           </div>

//           <div className="flex gap-2 justify-end">
//             <Button
//               type="primary"
//               style={{ background: "#06513D" }}
//               className="h-12 w-36 rounded-lg text-xs"
//               onClick={handleSetupProject}
//             >
//               Project Set-up
//             </Button>
//             <Button
//               type="primary"
//               style={{ background: "#06513D" }}
//               className="h-12 w-36 rounded-lg text-xs"
//               onClick={handleGenerateReport}
//             >
//               {openTableReports ? "Request New Report" : "Generate Report"}
//             </Button>
//           </div>
//         </div>

//         <hr className="my-4" />

//         <div className="flex flex-col lg:flex-row justify-between items-start gap-6">
//           <div className="overflow-x-auto w-full lg:w-2/3">
//             <table className="min-w-full text-sm border rounded-md">
//               <thead>
//                 <tr>
//                   {header.map((column) => (
//                     <th
//                       key={column.key}
//                       className="px-4 py-2 text-left font-semibold"
//                     >
//                       {column.label}
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {licenseTableSample[0].tableData.map((row, index) => (
//                   <tr key={index} className="hover:bg-gray-50">
//                     {header.map((column) => (
//                       <td key={column.key} className="px-4 py-2 text-left">
//                         {row[column.key]}
//                       </td>
//                     ))}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           <div className="flex flex-col sm:flex-row gap-8">
//             <div className="text-xs">
//               <p className="font-bold">PROJECT TYPE</p>
//               <p className="pt-4 font-bold">NUMBER OF USER LOGIN</p>
//               <p className="pt-4 font-bold">% OF USER</p>
//             </div>
//             <div className="text-xs">
//               <p>{projectData.projectType}</p>
//               <p className="pt-4">200/155</p>
//               <p className="pt-4">78%</p>
//             </div>
//           </div>

//           <div className="text-sm">
//             <p className="text-base mb-2">PROJECT STATUS</p>
//             <ul className="relative space-y-1">
//               {statusList
//                 .slice(0, statusList.indexOf(projectData.status) + 1)
//                 .map((item, index, arr) => (
//                   <li key={index} className="flex items-center gap-2">
//                     <div className="w-2 h-2 bg-[#06513D] rounded-full"></div>
//                     <span>{item}</span>
//                   </li>
//                 ))}
//             </ul>
//           </div>
//         </div>
//       </div> */}

//       {/* Main Content */}

//       <div className="bg-white border border-[#38A28D] rounded-md p-4 shadow-sm">
//         {/* Top Row */}
//         <div className="flex flex-wrap justify-between items-center gap-4 mb-6">
//           <div>
//             <p className="text-xs text-gray-500 font-medium">PROJECT NAME</p>
//             <p className="font-semibold">{projectName}</p>
//           </div>
//           <div>
//             <p className="text-xs text-gray-500 font-medium">START DATE</p>
//             <p className="font-semibold">{formatDate(projectData.startDate)}</p>
//           </div>
//           <div>
//             <p className="text-xs text-gray-500 font-medium">END DATE</p>
//             <p className="font-semibold">{formatDate(projectData.endDate)}</p>
//           </div>
//           <div className="flex gap-2">
//             <Button
//               type="primary"
//               style={{ background: "#06513D" }}
//               className="h-12 w-36 rounded-lg text-xs"
//               onClick={handleSetupProject}
//             >
//               Project Set-up
//             </Button>
//             <Button
//               type="primary"
//               style={{ background: "#06513D" }}
//               className="h-12 w-36 rounded-lg text-xs"
//               onClick={handleGenerateReport}
//             >
//               {openTableReports ? "Request New Report" : "Generate Report"}
//             </Button>
//           </div>
//         </div>

//         {/* Main Section - 3 sections in one row */}
//         <div className="flex gap-4 items-stretch">
//           {/* License Table - auto width */}
//           <div className="w-max">
//             <div className="h-full rounded overflow-x-auto">
//               <table className="table-auto text-[13px]  h-full">
//                 <thead>
//                   <tr className="text-left text-gray-600 font-semibold">
//                     {header.map((column) => (
//                       <th key={column.key} className="py-1 px-2 whitespace-nowrap">
//                         {column.label}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {licenseTableSample[0].tableData.map((row, index) => (
//                     <tr key={index} className="">
//                       {header.map((column) => (
//                         <td key={column.key} className="py-1 px-2 whitespace-nowrap text-center">
//                           {row[column.key]}
//                         </td>
//                       ))}
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>

//           {/* Project Info Section */}
//           <div className="flex-1 flex flex-col justify-center mt-5 h-full 0 rounded p-4 space-y-4 text-[13px]">
//             <div className="flex items-center">
//               <span className="font-semibold text-gray-600 w-40">PROJECT TYPE:</span>
//               <span className="text-gray-900 w-40">{projectData.projectType}</span>
//             </div>
//             <div className="flex items-center">
//               <span className="font-semibold text-gray-600 w-40">USER LOGIN:</span>
//               <span className="text-gray-900 w-40">200/155</span>
//             </div>
//             <div className="flex items-center">
//               <span className="font-semibold text-gray-600 w-40">% OF USER:</span>
//               <span className="text-gray-900 w-40">78%</span>
//             </div>
//           </div>

//           {/* Project Status Timeline */}
//           {/* Project Status Timeline */}
//           <div className="rounded min-w-[180px]">
//             <p className="text-gray-600 font-semibold mb-2">PROJECT STATUS</p>
//             <ul className="text-[12px] space-y-0 relative">
//               {statusList.map((status, idx) => {
//                 const isActive = status === currentStatus;
//                 const isCompleted = idx < currentStatusIndex;
//                 const isLast = idx === statusList.length - 1;

//                 // Debug each status
//                 console.log(`${idx}: ${status} | Active: ${isActive} | Completed: ${isCompleted}`);

//                 return (
//                   <li key={idx} className="flex gap-2 relative">
//                     <div className="flex flex-col items-center">
//                       <div
//                         className={`w-2 h-2 rounded-full ${isActive || isCompleted ? "bg-[#38A28D]" : "bg-gray-300"
//                           }`}
//                       ></div>
//                       {!isLast && (
//                         <div
//                           className={`w-[2px] flex-1 ${isCompleted ? "bg-[#38A28D]" : "bg-gray-300"
//                             }`}
//                           style={{ minHeight: "16px" }}
//                         ></div>
//                       )}
//                     </div>
//                     <div>
//                       <span
//                         className={`${isActive
//                             ? "text-[#06513D] font-semibold"
//                             : isCompleted
//                               ? "text-gray-700"
//                               : "text-gray-400"
//                           }`}
//                       >
//                         {status}
//                       </span>
//                     </div>
//                   </li>
//                 );
//               })}
//             </ul>
//           </div>

//         </div>

//       </div>

//       {!openTableReports ? (
//         <>
//           {!openAssignedForm ? (
//             <>
//               <div className="my-4">
//                 <StandardSurveyForm
//                   projectId={projectId}
//                   setOpenAssignedForm={handleAssigned}
//                   setAssignedFormtype={setAssignedFormtype}
//                 />
//               </div>
//               <div className="my-4">
//                 <DynamicForm
//                   projectId={projectId}
//                   setOpenAssignedForm={handleAssigned}
//                   setAssignedFormtype={setAssignedFormtype}
//                   clientId={clientId}
//                 />
//               </div>
//             </>
//           ) : (
//             <div className="my-4 mx-4 sm:mx-8">
//               <div className="flex justify-end mb-2">
//                 <Button
//                   style={{ background: "#06513D", color: "white" }}
//                   className="h-12 w-36 rounded-lg text-xs"
//                   onClick={() => setOpenAssignedForm(false)}
//                 >
//                   Assigned Form
//                 </Button>
//               </div>
//               <AssignedForm
//                 projectId={projectId}
//                 selectedRows={selectedUsers}
//                 assignedFormType={assignedFormType}
//                 selectedRole={selectedRole}
//                 setSelectedRole={setSelectedRole}
//                 formId={formId}
//                 setFormId={setFormId}
//               />
//             </div>
//           )}

//           <div className="my-4 bg-white">
//             <UserTable
//               showCheckboxes={openAssignedForm}
//               selectedRows={selectedUsers}
//               setSelectedRows={setSelectedUsers}
//               setOpenUserDetailsPage={setOpenUserDetailsPage}
//               clientId={clientId}
//               selectedRole={selectedRole}
//               formId={formId}
//               projectId={projectId}
//             />
//           </div>
//         </>
//       ) : (
//         <ReportTable
//           projectId={projectId}
//           selectedRows={selectedUsers}
//           assignedFormType={assignedFormType}
//         />
//       )}

//       {/* Dialogs */}
//       {openGenerateReports && (
//         <GenerateReport
//           onOpen={openGenerateReports}
//           onClose={() => setOpenGenerateReports(false)}
//         />
//       )}

//       {openSetupProject && (
//         <ProjectSetup
//           onOpen={openSetupProject}
//           onClose={() => setopenSetupProject(false)}
//         />
//       )}

//       {openScreenLockedPopup && (
//         <ScreenLock
//           onOpen={openScreenLockedPopup}
//           onClose={() => navigate("/organization/projects")}
//         />
//       )}
//     </div>
//   );
// };

// export default ProjectPage;

import React, { useState, useMemo, useCallback, useEffect } from "react";
import TextStyles from "../../../../../components/Elements/TextStyles/TextStyles";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as BackIcon } from "../../../../../assets/svgs/back-button.svg";
import { Button } from "antd";
import StandardSurveyForm from "./StandardSurveyForm";
import DynamicForm from "./DynamicForm";
import UserTable from "./UserTable";
import GenerateReport from "../DailogBoxes/GenerateReport";
import AssignedForm from "../AssignedForm/AssignedForm";
import ReportTable from "./ReportTable";
import { getApi } from "../../../../../api/api_instance";
import { API_URLS } from "../../../../../api/apiUrls";
import dayjs from "dayjs";
import { formatDate } from "../../../../../utils/UtilService";
import ScreenLock from "../DailogBoxes/ScreenLock";
import ProjectSetup from "../DailogBoxes/ProjectSetup";
import ProjectDetailPage from "./ProjectDetailPage";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import UnlockProjectBeforeAssign from "../DailogBoxes/UnlockProjectBeforeAssign";

const ProjectPage = ({ statusFrequency }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { projectName, projectId } = location.state || {};
  const [openGenerateReports, setOpenGenerateReports] = useState(false);

  const [showUnlockPopup, setShowUnlockPopup] = useState(false);
  const [openSetupProject, setopenSetupProject] = useState(false);
  const [setupProject, setSetupProject] = useState(false);

  const [openAssignedForm, setOpenAssignedForm] = useState(false);
  const [openUserDetailsPage, setOpenUserDetailsPage] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [assignedFormType, setAssignedFormtype] = useState("");
  const [openTableReports, setOpenTableReports] = useState(false);
  const [projectData, setProjectData] = useState({});
  const [selectedRole, setSelectedRole] = useState(null);
  const [lockProject, setLockProject] = useState(false);
  const [openScreenLockedPopup, setOpenScreenLockedPopup] = useState(false);
  const [clientId, setClientId] = useState();
  const [isProjectLocked, setProjectLocked] = useState(true);
  const [formId, setFormId] = useState(null);
  const [refreshKey, setRefreshKey] = useState(null);
  const [isProjectSetupCompleted, setIsProjectSetupCompleted] = useState(false);
  const [standardFormRefreshToken, setStandardFormRefreshToken] = useState(0);

  useEffect(() => {
    if (!openGenerateReports && openTableReports) {
      // Only refresh if ReportTable is visible
      setRefreshKey((prev) => prev + 1);
    }
  }, [openGenerateReports, openTableReports]);

  const handleBack = useCallback(() => {
    if (openTableReports) {
      setOpenTableReports(false); // Report table se bahar aaye
    } else if (location.state?.source === "projects-list") {
      navigate("/organization/projects", {
        state: {
          currentPage: location.state.currentPage,
          searchTerm: location.state.searchTerm,
          filterData: location.state.filterData,
          startDate: location.state.startDate,
          endDate: location.state.endDate,
          status: location.state.status,
          projectType: location.state.projectType,
        },
      });
    } else {
      navigate("/organization/projects"); // Project list par jaye
    }
  }, [navigate, openTableReports, location.state]);

  const handleGenerateReport = useCallback(() => {
    if (openTableReports) {
      setOpenGenerateReports(true);
    } else {
      setOpenTableReports(true);
    }
  }, [openTableReports]);

  const handleSetupProject = () => {
    setopenSetupProject(true);
  };

  const handleAssigned = useCallback(() => {
    setOpenAssignedForm(true);
  }, []);

  const fetchProjectDetails = useCallback(async () => {
    try {
      const response = await getApi({
        apiUrl: API_URLS.GET_PROJECT_BY_ID(projectId),
      });
      if (response.success) {
        let project_data = response.data;

        // Merge license from root and approval data
        const rootLicense = project_data.license || {};
        const approvalLicense = project_data.approval?.data?.[0]?.license || {};
        const combinedLicense = { ...approvalLicense, ...rootLicense };

        setProjectData({
          ...project_data,
          projectName: project_data.name,
          startDate: dayjs(project_data.startDate).format("DD/MMM/YYYY"),
          license: combinedLicense,
          projectType: project_data.project_type,
          status: project_data.status,
          statusFrequency: project_data.status_frequency,
        });
        setProjectLocked(
          project_data.status_frequency === "lock" ? true : false,
        );
        // ✅ Check if project setup is completed
        const hasExistingSetup =
          project_data.year &&
          project_data.year_value &&
          ((project_data.standard_form &&
            project_data.standard_form.length > 0) ||
            (project_data.dynamic_form &&
              project_data.dynamic_form.length > 0) ||
            (project_data.custom_form && project_data.custom_form.length > 0));

        setIsProjectSetupCompleted(hasExistingSetup);
        console.log("Project Setup Completed:", hasExistingSetup);

        if (
          project_data.status === "Project Setup Completed" &&
          (project_data.frequency === null ||
            project_data.frequency === undefined)
        ) {
          setLockProject(true);
        }
      }
      const rawClientId = response.data.assigned_by || response.data.client_id;
      setClientId(rawClientId?._id || rawClientId);
    } catch (error) {
      console.error("Error is fetching project details");
    }
  });

  const handleProjectSetupComplete = useCallback(() => {
    // Refresh project details after setup is completed
    fetchProjectDetails();
    // Force StandardSurveyForm to refetch standard forms immediately.
    setStandardFormRefreshToken((prev) => prev + 1);
  }, [fetchProjectDetails]);

  const header = useMemo(
    () => [
      { label: "STATUS OF LICENSE", key: "statusOfLicense" },
      { label: "TOTAL LICENSE", key: "totalLicense" },
      { label: "USED", key: "used" },
      { label: "REMAINING", key: "remaining" },
    ],
    [],
  );

  const licenseTableSample = useMemo(() => {
    const license = projectData.license || {};

    const licenseTypes = [
      // { key: "location_user", label: "LOCATION USER" },
      // { key: "location_admin", label: "LOCATION ADMIN" },
      { key: "user", label: "USER" },
      // { key: "sub_admin", label: "SUB ADMIN" },
      { key: "employee", label: "EMPLOYEE" },
      { key: "vendor", label: "VENDOR" },
      { key: "local_supervisor", label: "LOCAL SUPERVISOR" },
    ];

    const tableData = licenseTypes.map(({ key, label }) => {
      const value = license[key];
      const typeData =
        typeof value === "object" && value !== null ? value : { total: value };

      return {
        statusOfLicense: label,
        totalLicense: typeData.total ?? "0",
        used: typeData.used ?? "0",
        remaining: typeData.unused ?? (typeof value === "number" ? value : "0"),
      };
    });

    return [{ key: 1, tableData }];
  }, [projectData.license]);

  const statusList = useMemo(
    () => [
      "Project Created",
      "Project Setup Completed",
      "Form Submission in Progress",

      "Forms Submitted",
      "Report Requested",
      "Report Generated",
      "Audit Requested",
      // "Audit in  Progress",
      "Audit Completed",
      "Audit in Progress",
    ],
    [],
  );

  useEffect(() => {
    fetchProjectDetails();
  }, []);

  useEffect(() => {
    if (lockProject) {
      // Optional: trigger popup or redirect
    }
  }, [lockProject, isProjectLocked]);

  const currentStatus = projectData.status || "Project Created";
  const currentStatusIndex = statusList.indexOf(currentStatus);

  // console.log("Current Status:", currentStatus); // Should show "Audit Completed"
  // console.log("Current Status Index:", currentStatusIndex); // Should show 8 (last index)
  // console.log("Status List:", statusList);

  // const licenseData = [
  //   { role: "Location Admin", total: 15, used: 6, remaining: 6 },
  //   { role: "Location User", total: 20, used: 12, remaining: 12 },
  //   { role: "Employee", total: 20, used: 12, remaining: 12 },
  //   { role: "Vendor", total: 10, used: 2, remaining: 2 },
  // ];

  return (
    <div className="md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
      {/* Breadcrumb */}
      <div className="flex flex-wrap justify-end text-xs h-5 font-light gap-1 sm:gap-2">
        <p>Home</p>
        <span>/</span>
        <p>Projects</p>
        <span>/</span>
        <TextStyles style={{ color: "#06513D" }}>
          {" "}
          Project Details Page
        </TextStyles>
      </div>

      <div className="flex items-center gap-2 sm:mb-1.5 text-lg sm:text-xl font-bold flex-wrap">
        <IoArrowBackCircleOutline
          onClick={handleBack}
          className="w-8 sm:w-10 h-8 sm:h-10 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition"
        />
        <div className="text-[#06513D] font-[Calibri] text-[18px] sm:text-[20px] leading-none tracking-tight">
          Project Details Page
        </div>
      </div>

      {/* Main Content */}
      <div className="bg-white border border-[#38A28D] rounded-2xl p-4 shadow-sm">
        {/* Top Row */}
        <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4 mb-6">
          <div className="flex flex-col sm:flex-row gap-4 md:gap-6">
            <div>
              <p className="text-xs text-gray-500 font-medium">PROJECT NAME</p>
              <p className="font-semibold">{projectName}</p>
            </div>
            <div>
              <p className="text-xs text-gray-500 font-medium">START DATE</p>
              <p className="font-semibold">
                {formatDate(projectData.startDate)}
              </p>
            </div>
            <div>
              <p className="text-xs text-gray-500 font-medium">END DATE</p>
              <p className="font-semibold">{formatDate(projectData.endDate)}</p>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row gap-2">
            <Button
              type="primary"
              // style={{ background: "#06513D", hover: { background: "#387464" } }}
              className="h-12 w-full sm:w-36 rounded-lg text-xs"
              className="!bg-[#06513D] hover:!bg-[#387464] !text-white h-12 w-full sm:w-36 rounded-lg text-xs"
              onClick={handleSetupProject}
            >
              Project Set-up
            </Button>
            <Button
              type="primary"
              style={{
                background: isProjectSetupCompleted ? "#06513D" : "#d9d9d9",
                borderColor: isProjectSetupCompleted ? "#06513D" : "#d9d9d9",
                color: isProjectSetupCompleted ? "#fff" : "#8c8c8c",
              }}
              className="h-12 w-full sm:w-36 rounded-lg text-xs"
              onClick={handleGenerateReport}
              disabled={!isProjectSetupCompleted}
            >
              {openTableReports ? "Request New Report" : "Generate Report"}
            </Button>
          </div>
        </div>

        {/* Main Section - 3 sections in one row for desktop, stacked for mobile */}
        <div className="flex flex-col md:flex-row md:gap-4 md:items-stretch space-y-6 md:space-y-0">
          {/* License Table - auto width */}
          {/* <div className="w-full md:w-max">
            <div className="h-full rounded overflow-x-auto">
              <table className="table-auto text-[13px] h-full">
                <thead>
                  <tr className="text-left text-gray-600 font-semibold">
                    {header.map((column) => (
                      <th
                        key={column.key}
                        className="py-1 px-2 whitespace-nowrap"
                      >
                        {column.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {licenseTableSample[0].tableData.map((row, index) => (
                    <tr key={index} className="">
                      {header.map((column) => (
                        <td
                          key={column.key}
                          className="py-1 px-2 whitespace-nowrap text-center"
                        >
                          {row[column.key]}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div> */}
          <div
            className="w-full md:w-max bg-white rounded-lg"
            style={{
              boxShadow: "0px 4px 16px 0px rgba(59, 162, 185, 0.15)",
              // border: "1px solid #3BA2B959",
            }}
          >
            <div className=" rounded-lg overflow-x-auto">
              <table className="min-w-full border-collapse border border-gray-200 text-[13px]  text-center">
                <thead>
                  <tr className="text-gray-700 font-semibold bg-gray-50">
                    {header.map((column) => (
                      <th
                        key={column.key}
                        className="py-5 px-4 border border-gray-200 whitespace-nowrap"
                      >
                        {column.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {licenseTableSample[0].tableData.map((row, index) => (
                    <tr key={index} className="even:bg-gray-50 text-gray-700">
                      {header.map((column) => (
                        <td
                          key={column.key}
                          className="py-4 px-4 border border-gray-200 whitespace-nowrap text-center"
                        >
                          {row[column.key]}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Project Info Section */}
          <div className="flex-1 flex flex-col justify-center mt-0 md:mt-5 h-full rounded  space-y-2 text-[13px]">
            <div className="flex flex-col sm:flex-row sm:items-center">
              <span className="font-semibold text-gray-600 w-full sm:w-40">
                PROJECT SERVICES:
              </span>
              <span className="text-gray-900 w-full sm:w-40">
                {projectData.projectType}
              </span>
            </div>
            {/*  ????  */}
            {/* <div className="flex flex-col sm:flex-row sm:items-center">
              <span className="font-semibold text-gray-600 w-full sm:w-40">
                USER LOGIN:
              </span>
              <span className="text-gray-900 w-full sm:w-40">200/155</span>
            </div> */}
            {/* <div className="flex flex-col sm:flex-row sm:items-center">
              <span className="font-semibold text-gray-600 w-full sm:w-40">
                % OF USER:
              </span>
              <span className="text-gray-900 w-full sm:w-40">78%</span>
            </div> */}
          </div>

          {/* Project Status Timeline */}
          <div className="rounded min-w-[165px] ml-[-100px]">
            <p className="text-gray-600 font-semibold mb-2">PROJECT STATUS</p>
            <ul className="text-[12px] space-y-0 relative">
              {statusList.map((status, idx) => {
                const isActive = status === currentStatus;
                const isCompleted = idx < currentStatusIndex;
                const isLast = idx === statusList.length - 1;

                return (
                  <li key={idx} className="flex gap-2 relative">
                    <div className="flex flex-col items-center">
                      <div
                        className={`w-2 h-2 rounded-full ${
                          isActive || isCompleted
                            ? "bg-[#38A28D]"
                            : "bg-gray-300"
                        }`}
                      ></div>
                      {!isLast && (
                        <div
                          className={`w-[2px] flex-1 ${
                            isCompleted ? "bg-[#38A28D]" : "bg-gray-300"
                          }`}
                          style={{ minHeight: "16px" }}
                        ></div>
                      )}
                    </div>
                    <div>
                      <span
                        className={`${
                          isActive
                            ? "text-[#06513D] font-semibold"
                            : isCompleted
                              ? "text-gray-700"
                              : "text-gray-400"
                        }`}
                      >
                        {status}
                      </span>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>

      {!openTableReports ? (
        <>
          {!openAssignedForm ? (
            <>
              <div className="my-4">
                <StandardSurveyForm
                  projectId={projectId}
                  lockAction={isProjectLocked}
                  setOpenAssignedForm={handleAssigned}
                  setAssignedFormtype={setAssignedFormtype}
                  onSetupComplete={handleProjectSetupComplete}
                  refreshTrigger={standardFormRefreshToken}
                />
              </div>
              <div className="my-4">
                <DynamicForm
                  projectId={projectId}
                  setOpenAssignedForm={handleAssigned}
                  setAssignedFormtype={setAssignedFormtype}
                  clientId={clientId}
                />
              </div>
            </>
          ) : (
            <div className="my-4 mx-2 sm:mx-4 lg:mx-8">
              <div className="flex justify-end mb-2">
                <Button
                  style={{ background: "#06513D", color: "white" }}
                  className="h-10 lg:h-12 w-32 lg:w-36 rounded-lg text-xs"
                  onClick={() => setOpenAssignedForm(false)}
                >
                  Assigned Form
                </Button>
              </div>
              <AssignedForm
                projectId={projectId}
                selectedRows={selectedUsers}
                assignedFormType={assignedFormType}
                selectedRole={selectedRole}
                setSelectedRole={setSelectedRole}
                formId={formId}
                setFormId={setFormId}
              />
            </div>
          )}

          <div className="my-4 bg-white">
            <UserTable
              showCheckboxes={openAssignedForm}
              selectedRows={selectedUsers}
              setSelectedRows={setSelectedUsers}
              setOpenUserDetailsPage={setOpenUserDetailsPage}
              clientId={clientId}
              selectedRole={selectedRole}
              formId={formId}
              projectId={projectId}
            />
          </div>
        </>
      ) : (
        <ReportTable
          key={refreshKey}
          projectId={projectId}
          clientId={clientId}
          selectedRows={selectedUsers}
          assignedFormType={assignedFormType}
        />
      )}

      {/* Dialogs */}
      {openGenerateReports && (
        <GenerateReport
          onOpen={openGenerateReports}
          projectId={projectId}
          clientId={clientId}
          onClose={() => setOpenGenerateReports(false)}
        />
      )}

      {openSetupProject && (
        <ProjectSetup
          onOpen={openSetupProject}
          projectId={projectId}
          statusFrequency={projectData.statusFrequency}
          onClose={() => setopenSetupProject(false)}
          onSetupComplete={handleProjectSetupComplete}
        />
      )}

      {openScreenLockedPopup && (
        <ScreenLock
          onOpen={openScreenLockedPopup}
          onClose={() => navigate("/organization/projects")}
        />
      )}

      <UnlockProjectBeforeAssign
        onOpen={showUnlockPopup}
        onClose={() => setShowUnlockPopup(false)}
        handleSave={() => {
          setShowUnlockPopup(false); // close unlock popup
          setopenSetupProject(true); // open ProjectSetup
        }}
      />
    </div>
  );
};

export default ProjectPage;
